import React from 'react';
import { useAgency } from '../AgencyContext';
import TaskID from './TaskID';
import SidePannelAdmin from '../ManagerSideMenu/SidePannelAdmin';

const ManagerTaskView = () => {
  const { currentAgency } = useAgency();
  
  // Si ce n'est pas un manager, utiliser TaskID normal
  if (currentAgency?.userRole !== 'Manager') {
    return <TaskID />;
  }

  // Pour les managers, afficher le SidePannelAdmin avec TaskID comme contenu principal
  return <SidePannelAdmin taskView={<TaskID />} />;
};

export default ManagerTaskView;